module.exports = __webpack_public_path__ + "static/media/29EUNOG10.03810955.jpg";